/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Notifications32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlDarkBlue}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.75 22.333c0 .921-.783 1.667-1.75 1.667s-1.75-.746-1.75-1.667h3.5zM16.003 9c.96 0 1.75.75 1.75 1.667 2.079.47 3.497 2.083 3.497 5v2.491c0 .473.35 1.011.781 1.22l.094.044c.875.411.875 1.249.875 1.249v.829H9v-.836a1.48 1.48 0 01.878-1.249l.093-.044c.424-.202.779-.748.779-1.212v-2.492c0-2.917 1.136-4.534 3.5-5 0-.917.794-1.667 1.753-1.667z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default Notifications32;
